import React, { useState, useRef } from 'react';
import SearchBarStyled from './bundle.esm3.js';
import { defaultFunction, defaultPromises } from '../../utils/bundle.esm2.js';
import SearchBarItem from './SearchBarItem/bundle.esm.js';
import Dropdown from '../Dropdown/bundle.esm.js';
import { addOnClickPropertyToChild } from './bundle.esm4.js';
import SearchIconSVG from '../../assets/images/bundle.esm5.js';
import CrossCircleSVG from '../../assets/images/bundle.esm2.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SearchBar = (props) => {
  const { className, onSubmit = defaultPromises, SearchIcon } = props;
  const { placeholder, children, onChange = defaultFunction } = props;
  const { submitOnChange, dropdownConfigs } = props;
  const { onClear = defaultFunction, instance } = props;
  const { onInputBlur = defaultFunction } = props;
  const { onInputFocus = defaultFunction } = props;
  const { onInputClick = defaultFunction } = props;
  const { backdropConfig } = props;
  const [query, setQuery] = useState("");
  const [showCrossIcon, setShowCrossIcon] = useState(false);
  const searchBarWrapperRef = useRef(null);
  const [childIndex, setChildIndex] = useState(-1);
  const [showDropdown, setShowDropdown] = useState(false);
  const actualFocusableElement = useRef(null);
  const { showDropdown: showDropdownConfig } = dropdownConfigs != null ? dropdownConfigs : {};
  const { target = ["focus"] } = dropdownConfigs != null ? dropdownConfigs : {};
  const showOverlay = typeof showDropdownConfig !== "undefined" ? showDropdownConfig : showDropdown;
  const search = async (searchTerm) => {
    if (!searchTerm) {
      return;
    }
    try {
      await onSubmit(searchTerm);
      setShowDropdown(true);
    } catch (error) {
      console.error(error.message);
      setShowDropdown(false);
    }
  };
  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      instance == null ? void 0 : instance.saveSearchLocal(query);
    } catch (e2) {
      console.error("SearchBar: Cannot add the query to local storage");
    }
    search(query);
    setShowCrossIcon(true);
  };
  const changeHandler = (e) => {
    const { value } = e.target;
    setQuery(value);
    onChange(value);
    if (submitOnChange) {
      submitOnChange(value);
      search(value);
      try {
        instance == null ? void 0 : instance.saveSearchLocal(query);
      } catch (e2) {
        console.error("SearchBar: Cannot add the query to local storage");
      }
    }
    setShowCrossIcon(!!value);
  };
  const onBlur = () => {
    setChildIndex(-1);
    setShowDropdown(false);
    setShowCrossIcon(false);
    onInputBlur();
  };
  const inputFocusHandler = (event) => {
    setShowDropdown(true);
    if (!query) {
      return;
    }
    setChildIndex(-1);
    setShowCrossIcon(true);
    onInputFocus();
  };
  const clearInput = (event) => {
    event.preventDefault();
    setQuery("");
    setChildIndex(-1);
    setShowCrossIcon(false);
    setShowDropdown(false);
    onClear();
  };
  const onKeyPressHandler = (event) => {
    var _a, _b, _c, _d;
    const focusableElements = document.querySelectorAll(
      ".SearchBarItem__selectable"
    );
    const { key } = event;
    if (!(focusableElements == null ? void 0 : focusableElements.length)) {
      setChildIndex(-1);
      return;
    }
    if (key === "ArrowUp") {
      event.preventDefault();
      const prev = childIndex;
      (_a = actualFocusableElement.current) == null ? void 0 : _a.classList.remove(
        "SearchBar__item--active"
      );
      const prevIndex = prev - 1 < 0 ? 0 : prev - 1;
      const actualItem = (_b = focusableElements == null ? void 0 : focusableElements[prevIndex]) != null ? _b : null;
      actualItem == null ? void 0 : actualItem.classList.add("SearchBar__item--active");
      const idAttribute = actualItem == null ? void 0 : actualItem.getAttribute("id");
      if (idAttribute) {
        setQuery(idAttribute);
      }
      actualFocusableElement.current = actualItem;
      setChildIndex(prevIndex);
    }
    if (key === "ArrowDown") {
      event.preventDefault();
      const prev = childIndex;
      (_c = actualFocusableElement.current) == null ? void 0 : _c.classList.remove(
        "SearchBar__item--active"
      );
      const nextItem = prev + 1 > (focusableElements == null ? void 0 : focusableElements.length) - 1 ? (focusableElements == null ? void 0 : focusableElements.length) - 1 : prev + 1;
      const actualItem = (_d = focusableElements == null ? void 0 : focusableElements[nextItem]) != null ? _d : null;
      actualItem == null ? void 0 : actualItem.classList.add("SearchBar__item--active");
      const idAttribute = actualItem == null ? void 0 : actualItem.getAttribute("id");
      if (idAttribute) {
        setQuery(idAttribute);
      }
      actualFocusableElement.current = actualItem;
      setChildIndex(nextItem);
    }
  };
  return /* @__PURE__ */ React.createElement(SearchBarStyled, {
    className: `SearchBar ${className}`
  }, /* @__PURE__ */ React.createElement(Dropdown, __spreadProps(__spreadValues({}, dropdownConfigs), {
    className: "SearchBar__dropdown",
    overlay: addOnClickPropertyToChild(children, setQuery),
    target,
    showDropdown: showOverlay,
    backdropConfig
  }), /* @__PURE__ */ React.createElement("div", {
    className: "SearchBar__wrapper",
    ref: searchBarWrapperRef,
    onKeyDown: onKeyPressHandler
  }, /* @__PURE__ */ React.createElement("button", {
    onClick: submitHandler,
    className: "SearchBar__btn SearchBar__btn-search",
    disabled: !query,
    tabIndex: 0,
    "aria-label": "search"
  }, SearchIcon ? SearchIcon : /* @__PURE__ */ React.createElement(SearchIconSVG, null)), /* @__PURE__ */ React.createElement("input", {
    type: "text",
    placeholder,
    value: query,
    className: "SearchBar__input",
    onChange: changeHandler,
    onFocus: inputFocusHandler,
    onBlur,
    onClick: onInputClick,
    tabIndex: 0
  }), /* @__PURE__ */ React.createElement("div", {
    tabIndex: -1,
    className: "SearchBar__btn-container"
  }, showCrossIcon ? /* @__PURE__ */ React.createElement("button", {
    onMouseDown: clearInput,
    type: "button",
    className: "SearchBar__btn SearchBar__btn-cross"
  }, /* @__PURE__ */ React.createElement(CrossCircleSVG, null)) : null))));
};
SearchBar.defaultProps = {
  className: "",
  placeholder: "Buscar...",
  onChange: defaultFunction,
  onClear: defaultFunction,
  onSubmit: defaultPromises,
  onInputBlur: defaultFunction,
  onInputFocus: defaultFunction,
  onInputClick: defaultFunction,
  dropdownConfigs: {
    target: ["focus"]
  }
};
SearchBar.Item = SearchBarItem;

export { SearchBar as default };
//# sourceMappingURL=bundle.esm2.js.map
